define((require) => {
    "use strict";

    var $                    = require("jquery"),
        _                    = require("underscore"),
        DeleteGroupAction    = require("ui/actions/DeleteGroupAction"),
        GroupModel           = require("shared/ui/groups/GroupModel"),
        LoggedInUserState    = require("shared/ui/user/LoggedInUserState"),
        ExperienceThumbnailViewer = require("ui/viewer/ExperienceThumbnailViewer"),
        ExperienceThumbnailImageViewer = require("ui/viewer/ExperienceThumbnailImageViewer"),
        SceneThumbnailViewer = require("ui/viewer/SceneThumbnailViewer"),
        Tooltip              = require("ui/common/Tooltip"),
        Marionette           = require("marionette"),
        Permissions          = require("shared/security/Permissions"),
        PublishableState     = require("util/PublishableState"),
        Size                 = require("shared/util/Size"),
        SpinnerView          = require("shared/ui/common/SpinnerView"),
        template             = require("ui/dashboard/ContentItemView.tpl"),
        ThumbnailLayouter    = require("util/ThumbnailLayouter"),
        WarningMessages      = require("util/WarningMessages"),
        MatomoReportingModel = require("ui/reporting/MatomoReportingModel.js"),
        Configuration = require("shared/services/Configuration");

    var MAX_THUMB_DIMENSION = {width: 215, height: 140},
        MAX_VARIANT_THUMB_DIMENSION = {width: 130, height: 110};

    /**
     *
     * @class ContentItemView
     *
     */
    return Marionette.Layout.extend({

        _spectatorMode: null,

        _canDeleteExperiences: null,

        _group: null,

        _entries: null,

        _pending: false,

        /**
         * @type {SceneThumbnailViewer}
         */
        _sceneThumbnailViewer: null,

        className: "content-item experience-item",

        template: template,

        /**
         * Whether the view has been through it's rendering cycle.
         *
         * @type {Boolean}
         */
        rendered: false,

        regions: {
            spinnerRegion: ".spinner-region"
        },

        templateHelpers: function() {
            var state = this.model.getState(),
                readableState = state && state.displayName,
                canDelete = this._canDeleteExperiences,
                // HACK: See comments in #_showComments
                hasComments = (this._group ? this._group.getSortedAssets()[0] : this.model).has("lastCommentedAt"),
                hasMatomoReporting = LoggedInUserState.get("integrations").isMatomoReportingDashboardLinkVisibleIntegrationsEnabled();

            // console.log("readable state", readableState, this._group);

            if (this._group) {
                // FIXME: Seems weird to use the action for permission check?
                canDelete = new DeleteGroupAction(this._group).executable();
            }

            return {
                spectatorMode: this._spectatorMode,
                canDelete: canDelete,
                itemLabel: this._itemLabel,
                // Overwriting the name from the model to avoid js-injection
                name: this.model.get("name"),
                hasComments: hasComments,
                readableState: readableState,
                pending: this._pending,
                group: this._group,
                groupType: this._group && this._group.getDashedType(),
                entries: this._group && this._entries,
                thumbs: this._group && this._getThumbs(),
                hasMatomoReporting: hasMatomoReporting
            };
        },

        modelEvents: {
            "change:name": function(experienceModel, newName) {
                this.ui.title.text(newName);
            },

            "change:state": "render"
        },

        ui: {
            thumbContainer: ".experience-thumb-container",
            groupThumbContainer: ".group-thumb-container",
            thumbWrapper: ".experience-thumb-wrapper",
            duplicate: ".duplicate",
            delete: ".delete",
            report: ".report",
            commentsIndicator: ".comments-indicator",
            titleContainer: ".title-container",
            title: ".title",
            loadingSpinner: ".loading-spinner"
        },

        events: {
            "click @ui.thumbContainer": function(event) {
                event.preventDefault();
                event.stopPropagation();

                // Signal that we want to open the quick view
                this.viewScope.openQuickView(this.model);
            },

            "click @ui.groupThumbContainer": function(event) {
                event.preventDefault();

                // Signal that we want to open the quick view
                this.viewScope.openQuickView(this.model);
            },

            "click @ui.duplicate": function(event) {
                event.preventDefault();

                // Necessary to remove the tooltip on click
                $(event.target).trigger("mouseout");

                this._duplicate();
            },

            "click @ui.delete": function(event) {
                event.preventDefault();

                // Necessary to remove the tooltip on click
                $(event.target).trigger("mouseout");
                this._delete();
            },


            "click @ui.report": function(event) {
                event.preventDefault();

                // Necessary to remove the tooltip on click
                $(event.target).trigger("mouseout");
                this._createMatomoSegment();
            },

            "mouseover @ui.titleContainer": function() {
                this._addTooltipOnTitle();
            }
        },

        initialize: function() {
            this._spectatorMode = Permissions.Privileges.CREATE.cannot();
            // Must have Create privilege, but also Publish if the experience is pushed, published, or scheduled!
            this._canDeleteExperiences = Permissions.Privileges.CREATE.can() &&
                (!this.model.hasAtLeastState(PublishableState.PUSHED) || Permissions.Privileges.PUBLISH.can());

            this._group = this.model instanceof GroupModel ? this.model : null;
            this._itemLabel = this._group ? "Group" : "Experience";
            this._entries = this._group && this._group.getUniqueEntries();
        },

        onRender: function() {
            var experienceToRender = this._group ? this._entries[0][0] : this.model;

            this._renderThumbnail(experienceToRender);
            this._showComments();
            this.rendered = true;
        },

        _renderThumbnail: function(experienceModel) {
            var maxDimensions = this._group ? MAX_VARIANT_THUMB_DIMENSION : MAX_THUMB_DIMENSION;
            var isThumbnailsImageIntegrationsEnabled = LoggedInUserState.get("integrations").isThumbnailsImageIntegrationsEnabled();
            var isThumbnailsNativeContentIntegrationsEnabled = LoggedInUserState.get("integrations").isThumbnailsNativeContentIntegrationsEnabled();
            if (isThumbnailsImageIntegrationsEnabled) {
                this._sceneThumbnailViewer = new ExperienceThumbnailImageViewer({
                    model: experienceModel.get("scenes").at(0),
                    experience: experienceModel,
                    maxDimensions: maxDimensions,
                    showStaticScenes: true,
                    isThumbnailsNativeContentIntegrationsEnabled: isThumbnailsNativeContentIntegrationsEnabled
                });
            } else if (isThumbnailsNativeContentIntegrationsEnabled) {
                this._sceneThumbnailViewer = new ExperienceThumbnailViewer({
                    model: experienceModel.get("scenes").at(0),
                    experience: experienceModel,
                    maxDimensions: maxDimensions,
                    showStaticScenes: true
                });
            } else {
                this._sceneThumbnailViewer = new SceneThumbnailViewer({
                    model: experienceModel.get("scenes").at(0),
                    experience: experienceModel,
                    maxDimensions: maxDimensions,
                    showStaticScenes: true
                });
            }
            this.ui.thumbContainer.prepend(this._sceneThumbnailViewer.render().$el);
            this.$el.addClass(this.model.get("id"));
        },

        onShow: function() {
            Tooltip.add(this.ui.delete, {
                placement: "top",
                width: this._canDeleteExperiences ? 177 : 180
            });

            Tooltip.add(this.ui.duplicate, {
                placement: "top",
                width: !this._spectatorMode ? 152 : 180
            });

            Tooltip.add(this.ui.report, {
                placement: "top",
                width: !this._spectatorMode ? 152 : 180
            });
        },

        onClose: function() {
            // Make sure to properly close the viewer instance - it was added
            // to the DOM outside of the normal (Marionette) lifecycle - see #onRender
            this._sceneThumbnailViewer.close();
        },

        _addTooltipOnTitle: function() {
            // jQuery return a rounded width, so to make sure there is room for the title
            // we add 1 to the container width.
            var titleContainerWidth = this.ui.titleContainer.width() + 1,
                titleWidth = this.ui.title.width(),
                showTooltip = titleWidth > titleContainerWidth;

            if (showTooltip) {
                this._titleTooltip = Tooltip.add(this.ui.titleContainer, {
                    placement: "top",
                    width: "auto"
                });
            }
        },

        // Handle state of comments indicator
        _showComments: function() {
            // Either pick the current experience or the first ("createdAt") from the group model.
            // FIXME: The comments indication might be incorrect for experience meta data, since
            // they only include initial scenes...
            var experienceModel = this._group ? this._group.getSortedAssets()[0] : this.model;

            if (experienceModel.get("lastCommentedAt")) {
                var lastVisit = LoggedInUserState.getLastExperienceVisit(experienceModel.get("id"));

                // Check if there are unread comments since the last experience visit
                if (experienceModel.get("lastCommentedAt") > lastVisit.visit) {
                    this.ui.commentsIndicator.addClass("unread-comments");
                } else {
                    // Check if there are unread comments on any of the scenes
                    var scenes = _.union(
                            experienceModel.get("scenes").models,
                            [experienceModel.get("overlayScene")],
                            [experienceModel.get("backgroundScene")]
                        ),
                        hasComments  = _.find(scenes, (scene) => {
                            return scene.get("lastCommentedAt") && scene.get("lastCommentedAt") > (lastVisit.sceneVisits[scene.get("id")] || 0);
                        });

                    if (hasComments) {
                        this.ui.commentsIndicator.addClass("unread-comments");
                    }
                }
            }
        },

        _getThumbs: function() {
            if (!this._entries) {
                return null;
            }

            var primaryModel = this._entries[0][0],
                dimensions = _.map(this._entries, (variant) => {
                    return {
                        width: variant[0].get("width"),
                        height: variant[0].get("height")
                    };
                }),
                layouts;

            if (primaryModel && primaryModel.get("backdrop").isFitContainer()) {
                var first = dimensions[0],
                    size = new Size(first.width, first.height),
                    scaledSize = size.shrinkToAspectRatio(MAX_VARIANT_THUMB_DIMENSION.width / MAX_VARIANT_THUMB_DIMENSION.height);

                _.extend(first, scaledSize);
            }

            layouts = ThumbnailLayouter.calculateLayout(dimensions, {
                fitboxDimensions: {
                    width: MAX_VARIANT_THUMB_DIMENSION.width,
                    height: MAX_VARIANT_THUMB_DIMENSION.height
                }
            });

            return layouts;
        },

        /**
         * Duplicate the current experience item view
         */
        _duplicate: function() {
            this.viewScope.duplicate(this._group || this.model);
        },

        /**
         * @private
         *
         * Delete the experience/group associated with this item view.
         */
        _delete: function() {
            var self = this,
                model = self._group || self.model;

            this.ui.delete.addClass("invisible");

            // Show the spinner...
            this.spinnerRegion.show(new SpinnerView());

            var modelTypeText = model.get("type") !== "Experience" ? "Group" : "Experience"; // Simplify type for user messages. See MOS-1994.

            WarningMessages.fetchDeleteExperienceMessage(model, modelTypeText)
                .then((messagesText) => {
                    // ensure the `self.ui` keys have been converted from selector strings to jQuery elements.
                    self.bindUIElements();
                    // Remove spinner, i.e. empty the region...
                    self.spinnerRegion.close();
                    self.ui.delete.removeClass("invisible");
                    self.ui.delete.show();

                    // delay of 50ms to avoid the confirm box popping up before the rendering is complete.
                    _.delay(() => {
                        if (confirm(messagesText)) {
                            self.viewScope.delete(model);
                        }
                    }, 50);
                });
        },

        _createMatomoSegment: function() {
            // Show the spinner...

            var self = this;

            var experienceId = "";
            var experienceGroupId = "";
            var experienceGroupName = this.model.get("name");
            // if we have a group, then separate the experience ids so the api makes an OR rule here
            if (this._group) {
                var items = [];
                var experienceArray = this._group.getSortedAssets();
                experienceArray.forEach((item) => {
                    items.push(item.get("id"));
                });
                experienceGroupId = this.model.get("id");
                experienceId = items.join("::");
            } else {
                experienceId = this.model.get("id");
            }


            this.spinnerRegion.show(new SpinnerView());

            const matomoModel = new MatomoReportingModel();


            matomoModel.createNewSegment(experienceId, experienceGroupId, experienceGroupName)
                .then((matomoResponse) => {
                    const segmentDimension = matomoResponse.get("definition");
                    const url = Configuration.editorBaseUrl + "/#reporting/segment/" + segmentDimension;
                    window.location = url;
                })
                .always(() => {
                    self.spinnerRegion.close();
                });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/ContentItemView.js